<template>
    <div class="form-group">
        <!-- Delivery Address -->
        <div class="order-address-form__form-group form-group">
            <firm
                v-if="mode === 'business'"
                :required="firmRequired"
            />
            <email />
            <mobile-phone v-if="mode === 'private'"/>
        </div>
        <div class="order-address-form__form-group form-group">
            <prename />
            <surname />
        </div>
        <div class="order-address-form__form-group form-group">
            <floor-department />
            <street />
        </div>
        <div class="order-address-form__form-group form-group">
            <div class="order-address-form__form-group-item order-address-form__form-group-item">
                <div class="order-address-form__zip-place-container">
                    <postal-code/>
                    <place/>
                </div>
            </div>
            <phone/>
        </div>
        <div v-if="mode === 'business'" class="order-address-form__form-group form-group">
            <mobile-phone />
            <cost-center />
        </div>
        <div class="order-address-form__form-group form-group">
            <comment/>
        </div>
        <attention-by/>

        <div class="order-address-form__form-group form-group">
            <div class="order-address-form__form-group-item order-address-form__form-group-item--single">
                <early-invoice
                    v-if="!disableEarlyInvoice && mode === 'business'"
                    :text="earlyInvoiceText"
                />
                <invoice-per-post/>
                <same-invoice-address/>
            </div>
        </div>
    </div>
</template>

<script>
import _ from 'lodash';
import { validationMixin } from 'vuelidate';
import {
    required,
    minLength,
    maxLength,
    email,
    numeric,
} from 'vuelidate/lib/validators';
import { mapState } from 'vuex';

import EarlyInvoice from '../Checkout/EarlyInvoice.vue';
import Firm from './Fields/Firm.vue';
import Email from './Fields/Email.vue';
import Prename from './Fields/Prename.vue';
import Surname from './Fields/Surname.vue';
import FloorDepartment from './Fields/FloorDepartment.vue';
import Street from './Fields/Street.vue';
import PostalCode from './Fields/PostalCode.vue';
import Place from './Fields/Place.vue';
import Phone from './Fields/Phone.vue';
import MobilePhone from './Fields/MobilePhone.vue';
import InvoicePerPost from './Fields/InvoicePerPost.vue';
import SameInvoiceAddress from './Fields/SameInvoiceAddress.vue';
import CostCenter from './Fields/CostCenter.vue';
import Comment from './Fields/Comment.vue';
import AttentionBy from './Fields/AttentionBy.vue';

export default {
    components: {
        EarlyInvoice,
        Firm,
        Email,
        Prename,
        Surname,
        FloorDepartment,
        Street,
        PostalCode,
        Place,
        Phone,
        MobilePhone,
        InvoicePerPost,
        SameInvoiceAddress,
        CostCenter,
        Comment,
        AttentionBy,
    },
    mixins: [validationMixin],
    props: {
        disableEarlyInvoice: {
            type: Boolean,
            default: false,
        },
        earlyInvoiceText: {
            type: [String, Boolean],
            default: '',
        },
        commentText: {
            type: String,
            default: '',
        },
        firmRequired: {
            type: Boolean,
            default: false,
        },
    },
    data() {
        const deliveryAddress = _.cloneDeep(this.$store.state.order.delivery_address);
        const attentionBy = _.cloneDeep(this.$store.state.order.attention_by);
        const comment = _.cloneDeep(this.$store.state.order.comment);
        return {
            address: 'deliveryAddress',
            form: {
                deliveryAddress,
                attention_by: attentionBy,
                comment,
            },
        };
    },
    computed: {
        ...mapState({
            mode: state => state.mode,
            initDeliveryAddress: state => state.order.delivery_address,
        }),
    },
    watch: {
        initDeliveryAddress: {
            deep: true,
            handler() {
                this.form.deliveryAddress = this.initDeliveryAddress;
            },
        },
    },
    validations() {
        const deliveryAddress = {
            email_contact: {
                required,
                email,
            },
            firstname: {
                required,
            },
            lastname: {
                required,
            },
            street: {
                required,
            },
            zip: {
                required,
                numeric,
                minLength: minLength(4),
                maxLength: maxLength(4),
            },
            city: {
                required,
            },
            phone: {
                required,
            },
        };
        if (this.mode === 'business' && this.firmRequired) {
            return {
                form: {
                    deliveryAddress: {
                        ...deliveryAddress,
                        company: {
                            required,
                        },
                    },
                    attention_by: {
                        required,
                    },
                },
            };
        }
        return {
            form: {
                deliveryAddress,
                attention_by: {
                    required,
                },
            },
        };
    },
};
</script>



// WEBPACK FOOTER //
// DeliveryAddress.vue?7c9c866b